import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { alpha, useTheme } from "@mui/material/styles";
import { NavLink } from "react-router-dom";

export default function DesktopHeader({ modules = [], activeKey }) {
  const theme = useTheme();
  const headerPalette = theme.palette.header ?? {
    text: theme.palette.secondary.contrastText,
    tabInactive: alpha(theme.palette.secondary.contrastText, 0.75),
    tabActive: theme.palette.secondary.contrastText,
    indicator: theme.palette.secondary.contrastText,
  };

  return (
    <Tabs
      value={activeKey}
      variant="scrollable"
      scrollButtons="auto"
      textColor="inherit"
      TabIndicatorProps={{
        sx: {
          height: 3,
          borderRadius: "var(--radius-pill)",
          backgroundColor: headerPalette.indicator || headerPalette.text,
        },
      }}
      sx={{
        minHeight: 48,
        "& .MuiTab-root": {
          minHeight: 48,
          fontWeight: 600,
          textTransform: "none",
          color: headerPalette.tabInactive || alpha(headerPalette.text, 0.75),
        },
        "& .MuiTab-root.Mui-selected": {
          color: headerPalette.tabActive || headerPalette.text,
        },
      }}
    >
      {modules.map((tab) => (
        <Tab
          key={tab.key}
          value={tab.key}
          label={tab.title}
          component={NavLink}
          to={tab.path}
        />
      ))}
    </Tabs>
  );
}
